import { render, staticRenderFns } from "./ManagerLayout.vue?vue&type=template&id=568ec5fd&scoped=true&lang=pug&"
import script from "./ManagerLayout.vue?vue&type=script&lang=js&"
export * from "./ManagerLayout.vue?vue&type=script&lang=js&"
import style0 from "./ManagerLayout.vue?vue&type=style&index=0&id=568ec5fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ec5fd",
  null
  
)

export default component.exports